import Api from '../_base';
import cookie from 'react-cookies';
import axios from 'axios';

class GiftCardApiEpay {
	constructor() {
		this.get = this.get.bind(this);
		this.getConfig = this.getConfig.bind(this);

		this.urlBase = 'https://ecommerce-backend.yalo.com.br/api/';
		// this.urlBase = 'https://ecommerce-backend-hml-ecs.yalo.com.br/api/';
		if (window.location.hostname === 'qa.yalo.com.br')
			this.urlBase = 'https://ecommerce-backend-hml-ecs.yalo.com.br/api/';
		if (window.location.hostname === 'localhost')
			this.urlBase = 'https://ecommerce-backend-hml-ecs.yalo.com.br/api/';
	}

	getConfig(path, auth) {
		const config = Object.assign(
			{
				url: path
			},
			this.options
		);
		if (auth) {
			let token = cookie.load('SubToken');

			config.headers = Object.assign(
				{
					Authorization: 'bearer ' + token
				},
				config.headers
			);
		}

		return config;
	}

	get(path, auth = false) {
		path = this.urlBase + path;
		const config = {
			method: 'get',
			...this.getConfig(path, auth)
		};

		return axios(config).catch(this.notAuthenticated);
	}
	async sendingCode(data) {
		//const response = await ApiSubscription.post('', data, true);
		try {
			const response = await Api.get('/giftcode/' + data, true);
			return {
				data: response.data,
				status: response.status,
				statusText: response.statusText
			};
		} catch (err) {
			let error = err;
			return error;
		}
	}
}
export default new GiftCardApiEpay();

//localhost:80/api/giftcode/:code
//9234567899900007853
//TODO giftcard
